import 'vest/enforce/isURL';
import { create, enforce, test } from 'vest';

import type { ImportModalFormData } from './types';

export const importValidationSuite = create(({ link, action }: ImportModalFormData) => {
  test('link', 'Link is required', () => {
    enforce(link).isNotEmpty();
  });

  test('link', 'Link format is invalid (must be started with https://docs.google.com)', () => {
    enforce(link).isURL({
      protocols: ['https'],
      require_protocol: true,
      require_tld: false,
      host_whitelist: ['docs.google.com'],
      allow_underscores: true,
      disallow_auth: true,
      validate_length: false,
    });
  });

  test('action', 'Action is required', () => {
    enforce(action).isNotEmpty();
  });
});
